<template>
    <div class="container">
        Vous avez des questions, nous pouvons vous aider. N'hésitez pas à nous contacter à l'adresse suivante:
        <div>
            <a href="mailto:info@ondagoapp.com">info@ondagoapp.com</a>
        </div>
    </div>    
</template>

<script>
export default {
    
}
</script>

<style scoped>
.container {
    padding: 0px;
    text-align: left;
}
</style>